import PreviewNFTCard from "../card/PreviewNFTCard"
import {
  Avatar,
  DialogActions,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
} from "@mui/material"
import Box from "@mui/material/Box"
import Button from "@mui/material/Button"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import Typography from "@mui/material/Typography"
import React from "react"
import { capitalize } from "lodash"
import {
  GiAirZigzag,
  GiBarbedCoil,
  GiBeveledStar,
  GiBlaster,
  GiBullets,
} from "react-icons/gi"
import CloseIcon from "@mui/icons-material/Close"
import { getUri } from "../../utils/getFullUrl"

// Если первый символ в строке является строчным, то преобразовать его в заглавный
const conditionalCapitalize = (str) => {
  if (typeof str !== "string" || str.length === 0) return str
  return str[0] === str[0].toLowerCase() ? capitalize(str) : str
}

const Property = ({ icon, label, value }) => {
  return (
    <>
      <ListItem alignItems="flex-start" sx={{ p: { xs: 0, sm: 1 } }}>
        <ListItemAvatar
          sx={{
            display: { xs: "none", sm: "block" },
            minWidth: 50,
          }}
        >
          <Avatar
            sx={{
              width: 36,
              height: 36,
              color: "#bc8c4b",
              background: "rgba(188,140,75,0.1)",
              border: "1px solid rgba(188,140,75,0.15)",
            }}
            variant="rounded"
          >
            {icon}
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={label}
          secondary={
            <Typography
              sx={{ display: "inline" }}
              component="span"
              variant="body2"
              color="text.secondary"
            >
              {conditionalCapitalize(value)}
            </Typography>
          }
        />
      </ListItem>
      {label !== "Ability" && (
        <Divider
          variant="inset"
          component="li"
          sx={{
            display: { xs: "none", sm: "block" },
            marginLeft: "66px",
          }}
        />
      )}
    </>
  )
}

export const PreviewNFTDialog = ({
  item,
  closeDialog,
  maxWidth,
  onSellDepositDialog,
  onAddNftToGame,
}) => {
  return (
    <Box
      sx={{
        maxWidth,
        background: "#121212",
        textAlign: "center",
      }}
    >
      <DialogTitle sx={{ fontSize: "1rem", position: "relative", pr: 6 }}>
        {item.name}
        <IconButton
          aria-label="close"
          onClick={closeDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pt: 2, pb: 0 }}>
        <Typography
          mb={2}
          sx={{
            whiteSpace: { xs: "none", sm: "pre-wrap" },
            fontSize: { xs: 16 },
          }}
        >
          {item.description}
        </Typography>
        <Grid container spacing={2} alignItems="flex-start">
          <Grid item md={5}>
            <PreviewNFTCard
              imageUrl={getUri(
                "img",
                "webp",
                item.type,
                item.name,
                item.rarity,
              )}
              videoUrl={getUri(
                "video",
                "mp4",
                item.type,
                item.name,
                item.rarity,
              )}
              id={item.id}
              lvl={item.level}
              rarity={item.rarity}
              type={item.type}
              autoPlayVideo={true}
            />
          </Grid>

          <Grid item md={7}>
            <Grid container alignItems="flex-start">
              <Grid item xs={6}>
                <List sx={{ width: "100%", p: 0 }}>
                  <Property
                    icon={<GiAirZigzag className="primary" />}
                    label="Type"
                    value={item.type}
                  />
                  <Property
                    icon={<GiBeveledStar />}
                    label="Name"
                    value={item.name}
                  />
                  <Property
                    icon={<GiAirZigzag />}
                    label="Rarity"
                    value={item.rarity}
                  />
                  <Property
                    icon={<GiBeveledStar />}
                    label="Level"
                    value={item.level}
                  />
                </List>
              </Grid>

              <Grid item xs={6}>
                <List sx={{ width: "100%", p: 0 }}>
                  <Property
                    icon={<GiBullets />}
                    label="Base Damage"
                    value={item.baseDamage}
                  />
                  <Property
                    icon={<GiBlaster />}
                    label="Current Damage Bonus"
                    value={item.damage}
                  />
                  <Property
                    icon={<GiBarbedCoil />}
                    label="Ability"
                    value={item.ability}
                  />
                </List>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ p: 3 }}>
        <Stack
          flexWrap="wrap"
          spacing={2}
          useFlexGap
          sx={{ width: "100%", justifyContent: "space-between" }}
          direction="horizontal"
        >
          <Button
            disabled
            color="primary"
            variant="outlined"
            onClick={() => {
              closeDialog()
              onSellDepositDialog?.()
            }}
            sx={{ fontFamily: "RUSBoycott, sans-serif" }}
          >
            Sell on the Market
          </Button>

          <Stack flexWrap="wrap" direction="horizontal" useFlexGap spacing={1}>
            <Button
              disabled
              color="primary"
              variant="contained"
              onClick={() => {
                closeDialog()
              }}
              sx={{ fontFamily: "RUSBoycott, sans-serif" }}
            >
              Add to staking
            </Button>

            <Button
              disabled
              color="primary"
              variant="contained"
              onClick={() => {
                closeDialog()
                onAddNftToGame?.()
              }}
              sx={{ fontFamily: "RUSBoycott, sans-serif" }}
            >
              Add to the Game
            </Button>
          </Stack>
        </Stack>
      </DialogActions>
    </Box>
  )
}
